/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Habit } from '../../models/habit';

export interface GetHabitId$Plain$Params {

/**
 * Habit id
 */
  id: string;
  'api-version'?: string;
}

export function getHabitId$Plain(http: HttpClient, rootUrl: string, params: GetHabitId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
  const rb = new RequestBuilder(rootUrl, getHabitId$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Habit>;
    })
  );
}

getHabitId$Plain.PATH = '/habit/{id}';
